<template>
    <div>
        <trial-end-clock
            img-src="elapsed-time-red"
            :title="$t.__('common.labels.inactive_account')"
            :subtitles="[$t.__('pages.errors.TrialEndCartAvailable.thanks_valide_offer')]"
        >
            <CompassButton size="large" :label="buttonLabel" @click="goToCartLink"></CompassButton>
            <p class="typographies-paragraph-medium-semibold help-message__container">
                {{ $l10n.__('Besoin d’aide ?') }}
                <CompassLink
                    :label="$t.__('pages.errors.TrialEndCartAvailable.contact_support')"
                    link="javascript:;"
                    @click="contactSale"
                />
            </p>
        </trial-end-clock>
    </div>
</template>

<script>
import TrialEndClock from 'vcomponents/pages/errors/TrialEndClock.vue';
import { relocate } from 'utils/global.js';

export default {
    components: {
        TrialEndClock,
    },
    props: {
        // eslint-disable-next-line vue/no-unused-properties
        cartLink: {
            type: String,
            require: true,
            default: '',
        },
        // eslint-disable-next-line vue/no-unused-properties
        provider: {
            type: String,
            default: 'stripe',
        },
        // eslint-disable-next-line vue/no-unused-properties
        multipleQuotes: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        buttonLabel() {
            return this.multipleQuotes && this.provider !== 'chargebee'
                ? this.$l10n.__('Consulter mes offres')
                : this.$l10n.__('Valider mon offre');
        },
    },
    methods: {
        goToCartLink() {
            relocate(this.cartLink, this.provider === 'chargebee');
        },
        contactSale() {
            window.Intercom('show');
        },
    },
};
</script>
<style lang="scss" scoped>
.help-message__container {
    margin: 0;
}
</style>
